module.exports = __webpack_public_path__ + "static/media/midohiomarine.4f610bb6.png";


//////////////////
// WEBPACK FOOTER
// ./src/img/midohiomarine.png
// module id = 95
// module chunks = 0